import styled from '@emotion/styled';

const S = {};

S.HelpCenter = styled.section`
  label: HelpCenter;

  display: flex;
  flex-direction: column;
`;

S.HelpCenter.Title = styled.h2`
  label: Title;
  text-align: center;

  margin-bottom: 0.75rem;
`;

S.HelpCenter.Subtitle = styled.span`
  text-align: center;
`;

export default S;
